import Vue from 'vue'
import Router from 'vue-router'

const TheContainer = () => import('@/containers/TheContainer')
const Sheet = () => import('@/views/base/Sheet')
const Embedded = () => import('@/views/base/Embedded') 
const LandMap = () =>  import('@/views/map/LandMap')

const Database = () => import('@/views/online_scan/Database')
const DatabaseEntryForm = () => import('@/views/online_scan/DatabaseEntryForm')
const DatabaseViewDetail = () => import('@/views/online_scan/DatabaseViewDetail')

const ProductList = () => import('@/views/products/ProductList')
const ProductListByProject = () => import('@/views/products/ProductListByProject')
const ProductEntryForm = () => import('@/views/products/ProductEntryForm')
const ProductViewDetail = () => import('@/views/products/ProductViewDetail')

const ProductPostingList = () => import('@/module-product-posting/ProductPostingList')
const ProductPostingList_CTVOnly = () => import('@/module-product-posting/ProductPostingList_CTVOnly')
const ProductPostingEditor = () => import('@/module-product-posting/ProductPostingEditor')


const ClientList = () => import('@/module-client/ClientList')
const ClientEntryForm = () => import('@/module-client/ClientEntryForm')
const ClientViewDetail = () => import('@/module-client/ClientViewDetail')

const LocationViewer = () => import('@/views/map/LocationViewer')

const Validation = () => import('@/module-validation/Validation')

const ContactForm = () => import('@/module-form/Contact')
const ContactGCForm = () => import('@/module-form/ContactGC')
import PublicProductViewDetail from '@/views/products/PublicProductViewDetail'
import PublicProductPostingViewDetail from '@/views/products/PublicProductPostingViewDetail'

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      // redirect: '/v2/products',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'database',
          meta: {
            label: 'Database'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'online_scan',
              name: 'Dữ liệu quét online thủ công',
              component: Sheet,
              props: {sheet_id:'1CJlaGplqDjiOlCjh_bJQ4Sz7RK77TXf8EDq2V186VDc'} 
            },
            {
              path: 'online_scan_auto',
              name: 'Dữ liệu quét online tự động',
              component: Sheet,
              props: {sheet_id:'1LY_MSJcxW3EtdYiWxqWw8t6haTrsYc-WHxcLiSwApdE'} 
            },
            {
              path: 'online_scan_combined',
              name: 'Dữ liệu quét online (nhập chung)',
              component: Sheet,
              props: {sheet_id:'1XuCKf6jZhFzYV-Sj5GLAoBeBBAbSrnkUn5OnJD4nW9Q'} 
            },
            {
              path: 'online_scan/input',
              name: 'Nhập liệu',
              component: Embedded,
              props: {url:'https://docs.google.com/forms/d/e/1FAIpQLSdPkC_MI60I0cHc_BHx8G9rBFwdLoJdYQsRf3RM_RQjmEfveQ/viewform'} 
            },
            {
              path: 'online_scan/find',
              name: 'Tìm kiếm',
              component: Sheet,
              props: {sheet_id:'1Q-O7OODQBbmmdHpQqFYaiALizb_s-z7BLfP2-RpXu6k'} 
            },
            {
              path: 'online_scan/statistics',
              name: 'Thống kê',
              component: Sheet,
              props: {sheet_id:'1kNE_DSuQb3tUdq7xhqt6AJWTSP36ifxN8IhftLT_G3E'} 
            },
            {
              path: 'online_scan/analytics',
              name: 'Analytics',
              component: Sheet,
              props: {sheet_id:'1OEdul7-9aRBFCXQhkexW9vhfPFqVPf94EXofzgqbnjA'} 
            },
            {
              path: 'cart',
              name: 'Bất động sản ký gửi',
              component: Sheet,
              props: {sheet_id:'1HgRuVjl-7mTnjXpNukDdTy3q60S7EljLTN3rFtZOY0E'} 
            },
            {
              path: 'cart/find',
              name: 'Tìm kiếm',
              component: Sheet,
              props: {sheet_id:'1UVicNdDIGJoNDKoTCAm2Wbfahu2L0GCgh7QYWKBowjE'} 
            },
            {
              path: 'cart/analytics',
              name: 'Thống kê',
              component: Sheet,
              props: {sheet_id:'10UUT1la_g7OuR1UbZOzasCdKGZNpYDAO8Sqbn3FR2Ss'} 
            },

            {
              path: 'customers',
              name: 'Khách hàng',
              component: Sheet,
              props: {sheet_id:'1hgCVUyQXOpu_Vq1HcKcOS6YvsNKFssIcGP-urlPaRhQ'} 
            },
            {
              path: 'customers/find',
              name: 'Tìm kiếm',
              component: Sheet,
              props: {sheet_id:'1q_rK5OzW9gKuImSIMdPJQP97VzG4HcNLXMfkF5JOM4I'} 
            },
            {
              path: 'customers/analytics',
              name: 'Thống kê',
              component: Sheet,
              props: {sheet_id:'18OTJiqSL5tdCLNPYej7UfWkqslhXudLsx78wt_tzpw4'} 
            },
            {
              path: 'customers/care',
              name: 'Chăm sóc khách hàng',
              component: Sheet,
              props: {sheet_id:'1Ln-Ey1FDuCliyFw4y134jsE_q5Y5LnrZb2AO6xTJsaw'} 
            }
          ]
        },
        {
          path: 'map',
          meta: {
            label: 'Map'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'land',
              name: 'Bản đồ giá đất',
              component: LandMap
            }
          ]
        },
        {
          path: 'others',
          meta: {
            label: 'Others'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'street_code',
              name: 'Mã tên đường',
              component: Sheet,
              props: {sheet_id:'1AjqS2NGby3MsiXo_7fJarh_QgCRhci8_NVMK9bCC8ZE'} 
            },
            {
              path: 'finance',
              name: 'Tài chính',
              component: Sheet,
              props: {sheet_id:'1LzLESVM6dfXeqeHrirKIOGpRMaYa_1Oj5SwEKrmkbtg'} 
            }
          ]
        },
        {
          path: 'marketing',
          meta: {
            label: 'Marketing'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'posts',
              name: 'Tin đăng',
              component: Sheet,
              props: {sheet_id:'1c5jVr9Ye3j5_po1rKBpV_55TYTZJlrteUzSF5uYdyck'} 
            }
          ]
        },
        {
          path: 'sales',
          meta: {
            label: 'Sales'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'customers',
              name: 'Thống kê KH liên hệ',
              component: Sheet,
              props: {sheet_id:'1308a4EOoWZ4fwd19TWLbtJANczsA7M6nePqSxPQFCyc'} 
            }
          ]
        },
        
      ]
    },
    {
      path: '/contact-form',
      name: 'Contact',
      meta: {
        label: 'Nhu cầu Liên hệ'
      },
      component: ContactForm,
    },
    {
      path: '/contact-form-gc',
      name: 'ContactGC',
      meta: {
        label: 'Nhu cầu Liên hệ'
      },
      component: ContactGCForm,
    },
    // Public product detail page - accessible without login
    // Usage: /public-product/{product_id}
    // Example: /public-product/123
    {
      path: '/public-product/:id',
      name: 'PublicProductViewDetail',
      meta: {
        label: 'Thông tin bất động sản'
      },
      component: PublicProductViewDetail,
    },
    // Public product posting detail page - accessible without login
    // Usage: /public-products/{product_id}/posting/{product_posting_id}
    // Example: /public-products/123/posting/456
    {
      path: '/public-products/:productId/posting/:postingId',
      name: 'PublicProductPostingViewDetail',
      meta: {
        label: 'Thông tin tin đăng'
      },
      component: PublicProductPostingViewDetail,
    },
    {
      path: '/v2/',
      name: 'Home',
      component: TheContainer,
      // eslint-disable-next-line no-sparse-arrays
      children: [
        {
          path: 'online_scan',
          meta: {
            label: 'Dữ liệu quét'
          },
          component: Database,
        },
        {
          path: 'online_scan/analytics',
          meta: {
            label: 'Thống kê quét online'
          },
          component: Embedded,
          props: {url:'https://datastudio.google.com/embed/reporting/686adf1b-677b-4d22-aca6-aaa4102718d8/page/UYXZB'} 
          
        },
        {
          path: 'online_scan/:id',
          meta: {
            label: 'Nhập liệu'
          },
          component: DatabaseEntryForm,
        },
        ,
        {
          path: 'online_scan/:id/view',
          meta: {
            label: 'Xem thông tin'
          },
          component: DatabaseViewDetail,
          
        },

        {
          path: 'products',
          meta: {
            label: 'Ký gửi'
          },
          component: ProductList,
        },

        {
          path: 'products_by_projects',
          meta: {
            label: 'Ký gửi theo dự án'
          },
          component: ProductListByProject,
        },
        
        {
          path: 'products/analytics',
          meta: {
            label: 'Thống kê ký gửi'
          },
          component: Embedded,
          props: {url:'https://datastudio.google.com/embed/reporting/686adf1b-677b-4d22-aca6-aaa4102718d8/page/sYXZB'} 
          
        },

        {
          path: 'products/:id',
          meta: {
            label: 'Ký gửi'
          },
          component: ProductEntryForm,
        },
        {
          path: 'products/:id/view',
          meta: {
            label: 'Xem thông tin'
          },
          component: ProductViewDetail,
          
        },
        {
          path: 'products/:id/posting',
          meta: {
            label: 'Đăng tin'
          },
          component: ProductPostingEditor,
          
        },

        {
          path: 'posts',
          meta: {
            label: 'Đăng tin v2'
          },
          component: ProductPostingList,
          
        },

        {
          path: 'posts_readonly',
          meta: {
            label: 'Đăng tin v3'
          },
          component: ProductPostingList_CTVOnly,
        },

        {
          path: 'posts/analytics',
          meta: {
            label: 'Thống kê tin đăng'
          },
          component: Embedded,
          props: {url:'https://datastudio.google.com/embed/reporting/686adf1b-677b-4d22-aca6-aaa4102718d8/page/82ycB'} 
          
        },

        {
          path: 'clients',
          meta: {
            label: 'Khách hàng'
          },
          component: ClientList,
          
        },

        {
          path: 'clients/:id',
          meta: {
            label: 'Nhập liệu'
          },
          component: ClientEntryForm,
          
        },

        {
          path: 'clients/:id/view',
          component: ClientViewDetail,
          
        },

        {
          path: 'validation',
          component: Validation
        },
        

        {
          path: 'map',
          meta: {
            label: 'Bản đồ'
          },
          component: LocationViewer,
        },
      ]
    }
  ]
}

